import { render, staticRenderFns } from "./BiayaAdmin.vue?vue&type=template&id=59ca7f45&"
import script from "./BiayaAdmin.vue?vue&type=script&lang=js&"
export * from "./BiayaAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports